import { isBoolean } from 'lodash'
import { memo } from 'react'
import LoadingCustom from '../LoadingCustom'
import UnauthorizedScreen from '../UnauthorizedScreen'
import UserHelper from 'general/helpers/UserHelper'
import { Navigate } from 'react-router-dom'

const ProtectedRoute = ({ children, permission, noPermission, isLoading }) => {
  if (!isBoolean(permission)) return <></>
  const isAuth = UserHelper.checkAccessTokenValid()
  return isLoading ? (
    <LoadingCustom size="large" variant="primary" />
  ) : permission ? (
    isAuth ? (
      children
    ) : (
      <Navigate to="/auth/dang-nhap" />
    )
  ) : (
    (noPermission ?? <UnauthorizedScreen />)
  )
}

export default memo(ProtectedRoute)
